module.exports = __webpack_public_path__ + "img/Fortuna Multi Finance.df3ffd53.png";